import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { LngLat, Map, Marker } from 'mapbox-gl';
import { environment } from '@environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-map-modal',
  templateUrl: './map-modal.component.html',
  styles: [
    `
      #map {
        width: 100%;
        height: 100%;
      }

      button {
        position: fixed;
        top: 12%;
        right: 37%;
      }
    `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatDialogClose, MatIconModule],
})
export class MapModalComponent implements AfterViewInit {
  // Maps environments
  @ViewChild('map')
  public divMap?: ElementRef;
  public zoom: number = 13;
  public map?: Map | null;
  public marker?: Marker | null;
  public currentLngLat: LngLat = this.data.lngLat;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngAfterViewInit(): void {
    if (!this.divMap) throw 'El elemento HTML no fue encontrado';

    this.map = new Map({
      accessToken: environment.mapbox.accessToken,
      container: this.divMap.nativeElement,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: this.currentLngLat,
      zoom: this.zoom,
    });

    this.marker = new Marker({ color: 'red', draggable: true })
      .setLngLat(this.currentLngLat)
      .addTo(this.map);

    this.marker.on('dragend', marker => this.saveMarker(marker));
  }

  saveMarker(marker: any): void {
    if (!marker) throw 'El marcador es obligatorio';
    this.data.lngLat = marker.target._lngLat;
  }
}
